import React, { useState, useEffect } from 'react';
import { Row, Col, Checkbox, Button, Form } from 'antd';
import { InfoCircleOutlined, EditOutlined } from '@ant-design/icons';
import ServiceDrawer from '../ServiceDrawer';
import EssentialTag from '../Styled/EssentialTag';
import EssentialInfoDrawer from '../EssentialInfoDrawer';
import { useCustomer, useCustomerDispatch } from '../../common/customerContext';
import ProgressHeader from '../Styled/ProgressHeader';
import {
  CAMPAIGN_PRICING,
  CUSTOMER_ACTIONS,
  PER_MONTH,
  PER_SERVICE,
} from '../../constants';
import firstBy from 'thenby';
import { generateDisplayText } from '../../Helpers/generateDisplayText';
import useUpdateCurrentPage from '../../Hooks/CurrentPage';
import { sendSlackMessage } from '../../API/sendSlackMessage';
import { PriceItem } from '../../common/PriceItem';
import { formatMoney } from '../../Helpers/formatters';
import MostPopularTag from '../Styled/MostPopularTag';

const SelectServices = ({ onComplete, onServiceUpdate }) => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);
  const [isInfoDrawerVisible, setInfoDrawerVisible] = useState(false);
  const customer = useCustomer();
  const dispatch = useCustomerDispatch();
  const [selectedService, setSelectedService] = useState({});
  const [services, setServices] = useState(customer.services || []);
  const completionPercentage = 50;
  const essentialServices =
    services
      .filter((service) => service.location === 'essential')
      .sort(firstBy('order')) || [];
  const additionalServices =
    services
      .filter((service) => service.location === 'additional')
      .sort(firstBy('order')) || [];
  const [checkedServicesCount, setCheckedServicesCount] = useState(0);

  useEffect(() => {
    const count = services.filter((service) => service.included).length;
    setCheckedServicesCount(count);
  }, [services]);

  const serviceListConfigurationComplete = () => {
    try {
      const priceModel = CAMPAIGN_PRICING[customer.campaignCode] ?? PER_MONTH;

      const addedServices = services
        .filter((s) => s.included)
        .map((s) => PriceItem.mergeSavedService(s));
      const message = `Self Serve Review ${
        priceModel == PER_SERVICE ? 'No CC Required' : ''
      }
Customer: ${customer.firstName} ${customer.lastName}
Phone Number: ${customer.phoneNumber}
Email: ${customer.emailAddress}
Address: ${customer.googleAddress.formatted_address}
${
  priceModel == PER_SERVICE
    ? `Monthly Plan Amount: ${formatMoney(
        addedServices.reduce((acc, s) => acc + s.price, 0) / 12
      )}`
    : ''
}
Services:\n${addedServices
        .filter((s) => s.location != 'constant')
        .map(
          (s) =>
            `${s.name.trim()} at ${formatMoney(s.price / s.perYear)} /service`
        )
        .join('\n')}`;

      sendSlackMessage(message, `#self-serve-review-cart`);
    } catch (error) {}

    dispatch(CUSTOMER_ACTIONS.UPDATE_SERVICES, services);
    onComplete();
  };

  useUpdateCurrentPage();

  const onServiceChange = (service) => {
    setServices(
      services.map((s) => (s.serviceId === service.serviceId ? service : s))
    );
    onServiceUpdate(service);
  };

  console.log('CUSTOMER IN SELECT SERVICES IS ', customer);

  const ServiceList = ({ services, childServices }) => {
    return services.map((service) => {
      const children = childServices.filter(
        (s) => s.parentId && s.parentId == service.serviceId
      );

      if (service.location == 'constant') {
        return null;
      }
      return (
        <Col span={24} key={service.serviceId}>
          <label>
            <div
              className="input-box-radio"
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                padding: '12px',
                backgroundColor: 'white',
                // border: '2px solid #DAD6CC',
              }}
              onClick={() => {
                setSelectedService(service);
                toggleDrawer();
              }}
            >
              <Checkbox
                style={{ marginRight: '8px', pointerEvents: 'none' }}
                disabled={service.location === 'constant'}
                defaultChecked={service.included}
                onClick={(e) => e.stopPropagation()}
              />
              <div style={{ flex: 1, marginLeft: '10px' }}>
                <div>{service.name}</div>
                <div style={{ opacity: '.6', marginTop: '8px' }}>
                  {service.included
                    ? generateDisplayText(service, children)
                    : null}
                </div>
              </div>
              {service.popular && (
                <div>
                  <MostPopularTag text={'Most Popular'} />
                </div>
              )}
              {!service.popular &&
                (service.location === 'essential' ||
                  service.location == 'constant') && (
                  <div>
                    <EssentialTag text={'essential'} />
                  </div>
                )}

              <InfoCircleOutlined
                style={{
                  color: '#A2A3A5',
                  alignSelf: 'flex-start',
                  fontSize: '22px',
                  opacity: '0.6',
                }}
                onClick={() => {
                  setSelectedService(service);
                  toggleDrawer();
                }}
              >
                <EditOutlined />
              </InfoCircleOutlined>
            </div>
          </label>
        </Col>
      );
    });
  };

  const toggleDrawer = () => {
    setDrawerVisible(!isDrawerVisible);
  };

  const toggleInfoDrawer = () => {
    setInfoDrawerVisible(!isInfoDrawerVisible);
  };

  return (
    <Row
      gutter={[0, 16]}
      type="flex"
      justify="center"
      style={{ backgroundColor: '#F7F6F2' }}
    >
      <ProgressHeader
        title="Customize Your Plan"
        back={'hello'}
        completionPercentage={completionPercentage}
        hasNav={true}
      />

      <Col xs={0} md={5} lg={6}></Col>
      <Col
        xs={24}
        md={14}
        lg={12}
        align={'center'}
        style={{}}
        className="padMobile"
      >
        <div style={{ fontWeight: 400, marginTop: '8px' }}>
          We started you off with the{' '}
          <a
            onClick={(e) => {
              e.stopPropagation();
              setInfoDrawerVisible(true);
            }}
          >
            Essentials
          </a>
          , but feel free to customize your plan!
        </div>
      </Col>
      <Col xs={0} md={5} lg={6}></Col>

      <Col xs={0} md={5} lg={6}></Col>
      <Col xs={24} md={14} lg={12} style={{}} className="padMobile">
        <ServiceList
          services={[
            ...essentialServices,
            ...services.filter((s) => s.location == 'constant'),
          ]}
          childServices={services.filter((s) => s.parentId)}
          defaultChecked={true}
        />
      </Col>
      <Col xs={0} md={5} lg={6}></Col>

      <Col xs={0} md={5} lg={6}></Col>
      <Col xs={24} md={14} lg={12} style={{}} className="padMobile">
        <div style={{ fontWeight: 400, textAlign: 'center' }}>
          What other services would you like to add?
        </div>
      </Col>
      <Col xs={0} md={5} lg={6}></Col>

      <Col xs={0} md={5} lg={6}></Col>
      <Col xs={24} md={14} lg={12} style={{}} className="padMobile">
        <ServiceList
          services={additionalServices}
          childServices={services.filter((s) => s.parentId)}
        />
      </Col>
      <Col xs={0} md={5} lg={6}></Col>

      <Col xs={0} md={5} lg={6}></Col>
      <Col
        xs={24}
        md={14}
        lg={12}
        style={{}}
        className="padMobile"
        align={'center'}
      >
        {checkedServicesCount < 5 && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            4 services required to proceed
          </div>
        )}
        <Button
          style={{ marginBottom: '64px' }}
          type="primary"
          htmlType="submit"
          className="main-button"
          onClick={() => {
            serviceListConfigurationComplete();
          }}
          disabled={checkedServicesCount < 5}
        >
          Next
        </Button>
      </Col>
      <Col xs={0} md={5} lg={6}></Col>

      <ServiceDrawer
        visible={isDrawerVisible}
        onClose={toggleDrawer}
        service={selectedService}
        children={services.filter(
          (s) => s.parentId && s.parentId == selectedService?.serviceId
        )}
        onComplete={(service) => {
          onServiceChange(service);
          toggleDrawer();
        }}
      />
      <EssentialInfoDrawer
        visible={isInfoDrawerVisible}
        onClose={toggleInfoDrawer}
      />
    </Row>
  );
};

export default SelectServices;
